"use client";

import { c as _c } from "react/compiler-runtime";
import { useController, type Control, type FieldValues, type Path } from "react-hook-form";
import { SwitchInput, SwitchProps as SwitchInputProps } from "../rac/switch-input";
type RHFProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  rules?: Record<string, unknown>;
} & Omit<SwitchInputProps, "value" | "onChange" | "onBlur" | "errorMessage">;
export function SwitchField(t0) {
  const $ = _c(15);
  let control;
  let name;
  let rest;
  let rules;
  if ($[0] !== t0) {
    ({
      name,
      control,
      rules,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = control;
    $[2] = name;
    $[3] = rest;
    $[4] = rules;
  } else {
    control = $[1];
    name = $[2];
    rest = $[3];
    rules = $[4];
  }
  let t1;
  if ($[5] !== control || $[6] !== name || $[7] !== rules) {
    t1 = {
      name,
      control,
      rules
    };
    $[5] = control;
    $[6] = name;
    $[7] = rules;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const {
    field: t2,
    fieldState: t3
  } = useController(t1);
  const {
    onChange,
    onBlur,
    value
  } = t2;
  const {
    error
  } = t3;
  const t4 = error?.message;
  let t5;
  if ($[9] !== onBlur || $[10] !== onChange || $[11] !== rest || $[12] !== t4 || $[13] !== value) {
    t5 = <SwitchInput {...rest} isSelected={value} onChange={onChange} onBlur={onBlur} errorMessage={t4} />;
    $[9] = onBlur;
    $[10] = onChange;
    $[11] = rest;
    $[12] = t4;
    $[13] = value;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}